/**
 * Formats a duration in milliseconds into a human-readable string
 * using progressive precision: larger durations drop smaller units.
 *
 * Examples:
 *   0ms       → "0s"
 *   421ms     → "421ms"
 *   3200ms    → "3s"
 *   135000ms  → "2m 15s"
 *   5400000ms → "1h 30m 0s"
 *   5405000ms → "1h 30m 5s"
 *   90000000ms → "1d 1h"
 *   180000000ms → "2d"
 */
export function formatDuration(ms: number): string {
  if (ms <= 0) return '0s'

  const seconds = Math.round(ms / 1000)
  const minutes = Math.floor(seconds / 60)
  const remainderSeconds = seconds % 60
  const hours = Math.floor(minutes / 60)
  const remainderMinutes = minutes % 60
  const days = Math.floor(hours / 24)
  const remainderHours = hours % 24

  if (ms < 1000) return `${Math.round(ms)}ms`
  if (minutes < 1) return `${seconds}s`
  if (hours < 1) return `${minutes}m ${remainderSeconds}s`
  if (days < 1) return `${hours}h ${remainderMinutes}m ${remainderSeconds}s`
  if (days < 2) return `${days}d ${remainderHours}h`
  return `${days}d`
}
